import {
  MONUMPAY_DEPOSIT,
  MONUMPAY_DEPOSIT_SUCCESS,
  MONUMPAY_DEPOSIT_FAILURE,
} from "../actionTypes";

export const momumpayPayment = (payload) => ({
  type: MONUMPAY_DEPOSIT,
  payload,
});

export const momumpayPaymentSuccess = (payload) => ({
  type: MONUMPAY_DEPOSIT_SUCCESS,
  payload,
});

export const momumpayPaymentFailure = () => ({
  type: MONUMPAY_DEPOSIT_FAILURE,
});
